import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  clearError,
  selectCurrentError,
} from "@/store/redux/slices/error/error_slice";
import { logout } from "@/store/redux/slices/auth/auth_slice";
import { clearAccessToken } from "@/utils/token_functions";
import ErrorModal from "@/components/common/alerts/Error"; 


const GlobalErrorHandler = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const error = useSelector(selectCurrentError);

  const isDynamicPollsRoute = /^\/dynamic\/polls\//.test(location.pathname);
  useEffect(() => {
    if (isDynamicPollsRoute && error?.type === "AUTH") {
      dispatch(clearError());
    }
  }, [isDynamicPollsRoute, error, dispatch]);

  const handleClose = () => {
    dispatch(clearError());
  };

  const handleAction = () => {
    if (error && error.type === "AUTH") {
      clearAccessToken();

      dispatch(logout());

      dispatch(clearError());

      navigate("/signin");
      return;
    }

    dispatch(clearError());

    if (error && error.redirectTo) {
      navigate(error.redirectTo);
    }
  };

  if (!error || !error.type) return null;

  return (
    <ErrorModal
      isVisible={true}
      onClose={handleClose}
      header={error.title}
      paragraph={error.message}
      buttonText={error.action}
      recoveryPath={error.redirectTo}
      handleRecovery={handleAction} // Explicitly pass the custom handler
    />
  );
};

export default GlobalErrorHandler;
